var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1B1C",
    d: "M5.139 1c.304-.001.596.112.812.316l5.717 5.443a1.054 1.054 0 010 1.536l-5.717 5.443c-.454.37-1.13.345-1.552-.057a1.052 1.052 0 01-.06-1.479l4.906-4.671-4.906-4.67a1.05 1.05 0 01-.254-1.185A1.146 1.146 0 015.139 1z"
  })));
};
export default SvgArrowRight;